'use client';

import { BOLD_CONFIG } from '@/lib/payment-config';

type BoldCheckoutConstructor = new (config: Record<string, string>) => { open(): void };
declare global { interface Window { BoldCheckout?: BoldCheckoutConstructor } }
let loading: Promise<BoldCheckoutConstructor> | null = null;

/** API personalizada oficial: cargar una vez y crear una instancia por orden.
 * https://developers.bold.co/pagos-en-linea/boton-de-pagos/integracion-manual/integracion-personalizada
 */
export function loadBoldCheckout(): Promise<BoldCheckoutConstructor> {
  if (window.BoldCheckout) return Promise.resolve(window.BoldCheckout);
  if (loading) return loading;
  loading = new Promise<BoldCheckoutConstructor>((resolve, reject) => {
    const existing = document.getElementById('bold-checkout-sdk') as HTMLScriptElement | null;
    const script = existing || document.createElement('script');
    const cleanup = () => {
      clearTimeout(timeout);
      script.removeEventListener('load', ready);
      script.removeEventListener('error', fail);
    };
    const fail = () => {
      cleanup();
      script.remove();
      reject(new Error('No se pudo cargar el pago seguro de Bold.'));
    };
    const ready = () => {
      if (!window.BoldCheckout) { fail(); return; }
      cleanup(); resolve(window.BoldCheckout);
    };
    const timeout = window.setTimeout(fail, BOLD_CONFIG.timeout);
    script.addEventListener('load', ready);
    script.addEventListener('error', fail);
    if (!existing) {
      script.id = 'bold-checkout-sdk'; script.src = BOLD_CONFIG.scriptUrl; script.async = true;
      document.head.appendChild(script);
    }
  }).catch(error => { loading = null; throw error; });
  return loading;
}
